import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';
import { SessionExpired } from '../../features/auth/auth.actions';
import { SessionExpiredDialog } from './session-expired.dialog';

@Injectable({ providedIn: 'root' })
export class SessionExpiredService {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private store = inject(Store);

  private showing = false;

  async handleSessionExpired(): Promise<void> {
    if (this.showing) return;
    this.showing = true;

    // Limpia AuthState (y desde ahí se despacha ResetSubscriptions)
    this.store.dispatch(new SessionExpired());

    const returnUrl = this.router.url;

    try {
      await firstValueFrom(this.dialog
        .open(SessionExpiredDialog, {
          width: '420px',
          disableClose: true,
          autoFocus: false
        })
        .afterClosed())
    } finally {
      // Redirige SIEMPRE al login con returnUrl
      await this.router.navigate(['/auth/login'], {
        queryParams: { reason: 'expired', returnUrl }
      });

      // deja que el próximo 401 (después de reloguear) pueda volver a mostrar dialog si toca
      setTimeout(() => (this.showing = false), 500);
    }
  }
}